module.exports = __webpack_public_path__ + "img/dmidia.daaafd67.png";